import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { RestaurantAddress, Restaurant, OrderWithContext, BagPickupLocation } from '@/models';
import { stripNonNumerics } from '@/helpers';

@Component({
  name: 'CmgOrderConfirmationPickupInfo',
})
export default class CmgOrderConfirmationPickupInfo extends Vue {
  @Prop({ required: true, type: Object })
  address!: RestaurantAddress;

  @Prop({ required: true, type: Object })
  restaurant!: Restaurant;

  @Prop({ required: true, type: Boolean })
  paidInStore!: boolean;

  @Prop({ required: true, type: Object })
  order!: OrderWithContext;

  get mapImageUrl(): string {
    return this.$appStore.state.cms.images.icons.map.default;
  }

  get addressImageUrl(): string {
    const customer = this.$appStore.state.customer.profile;
    if (!this.address || !this.address.countryCode || !customer || !customer.country || this.address.countryCode == customer.country) {
      return this.mapImageUrl;
    }

    return this.$appStore.state.cms.images.countryFlags[this.address.countryCode.toLowerCase()].default;
  }

  get directionsImageUrl(): string {
    return this.$appStore.state.cms.images.icons.directions.default;
  }

  get isLowerShelfPickup(): boolean {
    return this.order && this.order.order.bagPickupLocationId == 3;
  }

  get mapDirections(): string {
    if (!this.address) {
      return '';
    }

    const { latitude, longitude } = this.address;
    if (!latitude || !longitude) {
      return '';
    }

    return this.$services.googleMaps.getDirectionsUrl(latitude, longitude);
  }

  get pillType(): string {
    return this.restaurant.digitalKitchen ? 'DIGITAL KITCHEN' : this.bagPickupLocationId == BagPickupLocation.Chipotlane ? 'CHIPOTLANE' : this.bagPickupLocationId == BagPickupLocation.WalkUpWindow ? 'WALK-UP' : '';
  }

  get pickupInstructions(): string | null {
    if (this.paidInStore) {
      return 'Go to the register to pickup and pay.';
    }

    if (!this.order) {
      return '';
    }

    return  this.bagPickupLocationId == BagPickupLocation.WalkUpWindow
      ? 'When you arrive head to the walk up window.'
      : this.bagPickupLocationId == BagPickupLocation.Chipotlane
      ? 'When you arrive, head to the drive-thru window and give the name on your order.'
      : 'Go straight to the pickup shelf to grab your order.';
  }

  get bagPickupLocationId(): BagPickupLocation {
      return this.order.order.bagPickupLocationId;
  }

  get animationOrVideoUrl(): string {
    if (this.paidInStore) {
      return this.$appStore.state.cms.animations.checkout.registerPickup;
    }

    if (!this.order) {
      return '';
    }

    return this.bagPickupLocationId == BagPickupLocation.WalkUpWindow
      ? this.$appStore.state.cms.images.walkUpWindow.default 
      : this.bagPickupLocationId == BagPickupLocation.Chipotlane
      ? this.$appStore.state.cms.animations.checkout.chipotlane
      : this.$appStore.state.cms.animations.checkout.shelfPickup;
  }

  get isVideoUrl(): boolean {
    const url = this.animationOrVideoUrl;
    return url.slice(url.lastIndexOf('.')) == '.mp4';
  }

  get favoriteLocationIconUrl(): string {
    const isFavorite = this.restaurant && this.$services.customer.isFavoriteRestaurant(this.restaurant.restaurantNumber);
    const icons = this.$appStore.state.cms.images.icons;

    return isFavorite ? icons.heartFilled.default : icons.heartEmpty.default;
  }

  get directions(): string | null {
    const directions = this.restaurant && this.restaurant.directions;
    if (!directions) {
      return null;
    }

    return `${directions.crossStreet1 ? `${directions.crossStreet1}${directions.crossStreet2 ? ` & ${directions.crossStreet2}` : ''}. ` : ''}${directions.landmark || ''}`;
  }

  get formattedPostalCode(): string {
    return (this.address.postalCode || '').split('-')[0];
  }

  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get instructionsHeader(): string {
    return this.order.order.bagPickupLocationId == BagPickupLocation.Chipotlane ? 'CHIPOTLANE PICKUP' : 'PICKUP INSTRUCTIONS';
  }
}
